<template>
  <pui-flex flex="1" class="poster-family-carousel poster-family-carousel__root">
    <pui-chip
      class="poster-family-carousel__chip"
      v-for="item in items"
      :key="getItemId(item)"
      outlined
      rounded
      borderColor="var(--color-primary)"
      hoverColor="#fff"
      hoverBackgroundColor="var(--color-primary-light)"
      @clickContent="$emit('change', [item])"
      :active="selectedIds.includes(getItemId(item))"
    >
      {{ piivoTranslate(item) }}
    </pui-chip>
  </pui-flex>
</template>

<script>
import Vue from 'vue';
import dragScrollMixin from 'piivo-ui/src/mixins/dragScroll';

export default {
  name: 'poster-family-carousel',
  mixins: [dragScrollMixin],
  props: {
    /**
     * Array of families
     */
    items: {
      type: Array,
      default: () => [],
    },
    /**
     * The selected families
     */
    value: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    /**
     * @returns {string[]} array of selected family ids
     */
    selectedIds() {
      return this.value.map(f => this.getItemId(f));
    },
  },
  methods: {
    // FILTERS
    piivoTranslate(value) {
      return Vue.filter('piivoTranslate')(value);
    },
    /**
     * @param {object} family - poster family object
     * @returns {string} the id of the family
     */
    getItemId(family) {
      return family.itemId;
    },
  },
};
</script>
